<style>
  #MyListMenu li {
    list-style: none;
  }

  .Lvl2 {
    margin: 10px 20px;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title"> ثبت سرویس تجهیز '{{inner_PM.deviceBehfa.codeBEHFA}}' طبق برنامه '{{inner_PM.title}}' </h5>

    <br>
    <br>

    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">تاریخ سرویس</label>
        <input type="text" #datepickerInputServiceDate placeholder="اینجا تایپ کنید ..." class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputServiceDate">
        </ng-persian-datepicker>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">شرح</label>
        <input [(ngModel)]="Submit_Dsc" name="Submit_Dsc" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
      </div>

    </div>

    <br />
    <hr />
    <br />

    <h5 class="card-title">چک لیست دوره سرویس</h5>

    <div class="row">

      <ng-container *ngFor="let lvl1 of DataList_PM_Item">

        <div class="form-group col-md-3">
          <ul d="MyListMenu">
            <b>{{lvl1.title}}</b>

            <li *ngFor="let lvl2 of lvl1.detail" style="list-style: none;">
              <input type="checkbox" class="Lvl2" (change)="item_Data_Change(lvl2)" [checked]="lvl2.selected" /> {{lvl2.title}}
            </li>

          </ul>
        </div>

      </ng-container>


    </div>

    <br />
    <hr />
    <br />


    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />

    <button *ngIf="!InProccessing && !Done" type="button" (click)="SubmitPMForm(datepickerInputServiceDate.value)"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>


  </div>
</div>
